import { Button } from "@ab-inbev-maz/compass";
import { useNavigate } from "react-router-dom";

interface NavigationHeaderProps {
  title: string;
  description: string;
  backLink?: string;
  action?: string;
  icon?: string;
  ButtonDownloadTemplate?: React.ReactNode;
  actions?: React.ReactNode[];
}
const NavigationHeader = ({
  title,
  description,
  backLink,
  actions

}: NavigationHeaderProps) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (backLink) {
      void navigate(backLink);
    } else {
      void navigate(-1);
    }
  };

  return (
    <section className="flex items-center justify-between p-4 gap-6">
      <section className="flex items-center gap-4">
        <Button
          icon="arrow/arrow-left"
          variant="secondary"
          onClick={handleBackClick}
          className="cursor-pointer"
        />

        <article>
          <h1 className="text-2xl font-bold text-gray-900 mb-1">{title}</h1>
          <p className="text-gray-600 text-xs">{description}</p>
        </article>
      </section>

      {actions && (
        <section className="flex items-center gap-2">
          {actions.map((action, index) => (
            <div key={index}>
              {action}
            </div>
          ))}
        </section>
      )}
    </section>
  );
};

export default NavigationHeader;